module.exports = __webpack_public_path__ + "img/displacementHor-needle.6c9c626a.svg";